import React, { useState } from 'react';
import classes from "./Leaderboard.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Container from '../component/Container';
import { useEffect } from 'react';
import { monthlyLeaderboardApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import BottomNavbar from '../component/BottomNavbar';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import { useTranslation } from 'react-i18next';

const Leaderboard = () => {
    const [type, setType] = useState("fantasy");
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [fantasyLeaderboard, setFantasyLeaderboard] = useState([]);
    // const [predictionLeaderboard, setPredictionLeaderboard] = useState([]);
    // const [leaderboard, setLeaderboard] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);
            const response = await monthlyLeaderboardApi(userDetails?.token);
            setFantasyLeaderboard(response?.data?.fantasy);
            // setPredictionLeaderboard(response?.data?.prediction);
            // setLeaderboard(response?.data?.win);
            setLoading(false);

        } catch (error) {
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
                console.log(error, 'error---');
            }

            console.log("error---");
        }
    }
    useEffect(() => {
        fetchLeaderboard();
    }, []);

    console.log({ fantasyLeaderboard }, 'data-----');
    return (
        <Layout>
            <SubLayout>
                <Header active={3} />

                <div className={classes.tabs_container}>
                    <button type='button' className={`${classes.tab_option} ${type === "fantasy" && classes.active}`}
                        onClick={() => setType("fantasy")}
                    >
                        {t("112")}
                    </button>
                    {/* <button type='button' className={`${classes.tab_option} ${type === "predict" && classes.active}`}
                        onClick={() => setType("predict")}
                    >
                        {t("113")}
                    </button> */}
                    {/* <button type='button' className={`${classes.tab_option} ${type === "win" && classes.active}`}
                        onClick={() => setType("win")}
                    >
                        Winners Leaderboard
                    </button> */}
                </div>

                <Container>

                    {loading ? <SmallLoader /> : (
                        <>
                            <div className={classes.leaderboard_container}>

                                {/* HERE SHOW USER RANK + POINTS... */}

                                <div className={classes.headings}>
                                    <div className={classes.rank_heading}>
                                        {t("114")}
                                    </div>
                                    <div className={classes.number_heading}>
                                        {t("115")}

                                    </div>
                                    <div className={classes.points_heading}>
                                        {t("116")}

                                    </div>
                                </div>
                                {/* {(type == "fantasy" ? fantasyLeaderboard : type=="predict" ? predictionLeaderboard : leaderboard)?.map((data, index) => { */}
                                {(fantasyLeaderboard)?.map((data, index) => {
                                    return (
                                     <div className={`${userDetails?.id == data?.user_id ? classes.leaderboard_active : classes.leaderboard_data}`} key={index}>
                                            <div className={classes.rank_data}>
                                                {data?.rank}
                                            </div>
                                            <div className={classes.number_data}>
                                                {data?.user_id}
                                            </div>
                                            <div className={classes.points_data}>
                                                {data?.total_points}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </>
                    )}


                </Container>
            </SubLayout>
        </Layout>
    )
}

export default Leaderboard